<template lang="pug">
.habit-confirmation-wrapper
  b-row(v-if="isSubmitting")
    b-col(cols="12")
      b-card.py-5
        b-card-body.text-center
          loading(
            :active="true" 
            :is-full-page="false"
            color="#498ceb"
          )

  b-row(v-else-if="respondAccessDenied")
    b-col(cols="12")
      b-card
        b-card-body.text-center
          feather-icon(icon="LockIcon", size="48", class="text-danger mb-2")
          h5 {{ $t('message.controlResponseNotAssignedToYou') }}

  b-row(v-else-if="respondAlreadyCompleted")
    b-col(cols="12")
      b-card
        b-card-body.text-center
          feather-icon(icon="CheckCircleIcon", size="48", class="text-success mb-2")
          h5 {{ $t('message.controlResponseAlreadySubmitted') }}

  div(v-else)
    validation-observer(ref="eventInfo", tag="form")
      b-row
        b-col(cols="12")
          b-card(:title="processName", :sub-title="process.goal")
            b-card-text
              div.mb-2
                | {{ process.description }}
              div.mb-1
                | {{ $t('message.tableHeader.inherentRisk') }}:
                span(v-if="process.inherentRisk", :style="{ color: residualRiskColors[process.inherentRisk || 'medium'], 'font-weight': 'bold' }")
                  |  {{ $t(`residualRisk.${process.inherentRisk}`) }}
              div
                | {{ $t('message.tableHeader.residualRisk') }}:
                span(v-if="process.residualRisk", :style="{ color: residualRiskColors[process.residualRisk || 'medium'], 'font-weight': 'bold' }")
                  |  {{ $t(`residualRisk.${process.residualRisk}`) }}
        b-col(cols="12", v-if="controlIndex == null")
          b-card(:title="$t('message.information_event_confimation')")
            b-alert(v-if="isForm && isNewConfirmation", show, variant="warning", class="d-flex align-items-center p-1 form-notice-alert")
              feather-icon(icon="AlertTriangleIcon", size="18", class="mr-50 flex-shrink-0")
              span {{ $t('message.formSelfAssessmentNotice') }}
            b-form-group
              label.control-field-label {{ $t('label.evaluator') }}
              validation-provider(:name="$t('label.evaluator')", rules="required", v-slot="{ errors }")
                v-select#v-select-worker(
                  v-model="selectedSupervisor",
                  :reduce="(worker) => worker.value",
                  :disabled="selectSupervisorDisabled",
                  :options="workersTotal",
                  :selectable="worker => !worker.deleted",
                  :placeholder="$t('placeholder.select_evaluador')",
                  label="title"
                )
                small(class="text-danger") {{ errors[0] }}
            b-form-group
              label.control-field-label {{ $t('label.evaluated') }}
              validation-provider(:name="$t('label.evaluated')", rules="required", v-slot="{ errors }")
                v-select#v-select-worker(
                  v-model="selectedWorker",
                  :reduce="(workersSupervised) => workersSupervised.value",
                  :disabled="selectWorkerDisabled",
                  :options="workersSupervised",
                  :selectable="worker => !worker.deleted",
                  :placeholder="$t('placeholder.select_evaluado')",
                  label="title"
                )
                small(class="text-danger") {{ errors[0] }}
            b-form-group(:label="$t('label.fetch_confirmation')", label-for="v-date", label-class="control-field-label")
              b-form-datepicker#v-date(v-model="event.date", :disabled="selectDateDisabled")

            //b-form-group(label="Hora de inicio", label-for="v-time")
              b-form-timepicker#v-code(v-model="event.start")
            //b-form-group(label="Hora de término", label-for="v-time")
              b-form-timepicker#v-code(v-model="event.end")

            div.text-right.mt-2(v-if="!isNewConfirmation && process.confirmationId")
              b-button(
                :disabled="isReloadingControlsStatus",
                v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                variant="outline-primary",
                @click="reloadControlsStatus"
              )
                b-spinner(v-if="isReloadingControlsStatus", small, class="mr-50")
                feather-icon(v-else, icon="RefreshCwIcon", size="16", class="mr-50")
                | {{ $t('message.reloadEvaluations') }}

        b-col(cols="12", v-if="controlIndex == null && process.activities && process.activities.length")
          b-card
            div.d-flex.align-items-center.control-title-toggle(@click="toggleResponsiblesCollapsed")
              feather-icon(:icon="responsiblesCollapsed ? 'ChevronRightIcon' : 'ChevronDownIcon'", size="18", class="mr-50 flex-shrink-0")
              h4.card-title.mb-0 {{ $t('message.controlResponsiblesTitle') }}
            template(v-if="!responsiblesCollapsed")
              p(class="control-responsibles-text mb-2")
                | {{ (isNewConfirmation ? $t('message.controlResponsiblesNoticeNewMain') : $t('message.controlResponsiblesNoticeEditMain')) + ' ' }}
                strong {{ isNewConfirmation ? $t('message.controlResponsiblesNoticeNewBold') : $t('message.controlResponsiblesNoticeEditBold') }}

              b-row(
                v-for="(control, controlResponsibleIdx) in process.activities",
                :key="controlResponsibleIdx",
                class="control-responsible-row align-items-start mb-2 pb-1"
              )
                b-col(cols="12", class="d-flex align-items-center")
                  span {{ controlResponsibleIdx + 1 }}- {{ control.name }}
                  feather-icon(
                    v-if="controlIndex == null && showGoToControlIcon",
                    icon="ArrowDownCircleIcon",
                    size="16",
                    class="ml-50 go-to-control-icon",
                    v-b-tooltip.hover="$t('message.goToControl')",
                    @click="goToControl(controlResponsibleIdx)"
                  )
                b-col(md="6", class="mt-50")
                  v-select(
                    v-model="control.responsible_id",
                    :reduce="(worker) => worker.value",
                    :options="workersTotal",
                    :selectable="worker => !worker.deleted",
                    :disabled="control.responsibleLocked",
                    :placeholder="$t('placeholder.responsible')",
                    label="title",
                    class="control-responsible-select"
                  )
                    template(v-slot:option="worker")
                      span {{ worker.title }}
                      span(v-if="worker.email", class="worker-email worker-email-value") - {{ worker.email }}
                      span(v-else, class="worker-email text-danger") - {{ $t('message.noEmail') }}
                    template(v-slot:selected-option="worker")
                      span.selected-worker-info
                        span.selected-worker-name {{ worker.title }}
                        span(v-if="worker.email", class="selected-worker-email worker-email-value") {{ worker.email }}
                        span(v-else, class="selected-worker-email text-danger") {{ $t('message.noEmail') }}
                b-col(md="6", class="d-flex align-items-center control-responsible-actions mt-50")
                  b-form-checkbox(
                    v-if="!control.responsibleLocked",
                    v-model="control.applyToBaseControl",
                    :disabled="control.responsible_id === control._initialResponsibleId",
                    switch,
                    class="mt-50 mb-0 mr-2"
                  )
                    | {{ $t('message.applyToBaseControl') }}
                  b-form-checkbox(
                    v-if="!continueConfirmation && control.responsible_id",
                    v-model="control.skipNotification",
                    switch,
                    class="mt-50 mb-0"
                  )
                    | {{ $t('message.skipControlNotification') }}
                  b-button(
                    v-if="continueConfirmation && process.confirmationId && !control.responsibleLocked && control.responsible_id",
                    variant="success",
                    size="sm",
                    class="ml-50",
                    :disabled="control.isSavingResponsible",
                    @click="saveControlResponsible(control, controlResponsibleIdx)"
                  )
                    b-spinner(v-if="control.isSavingResponsible", small)
                    span(v-else) {{ $t('message.save_and_send_mail') }}
                b-col(md="6", class="mt-50")
                  b-form-group(:label="$t('label.populationSize')", class="mb-0")
                    b-form-input(
                      v-model="control.population"
                      type="text"
                      :placeholder="$t('placeholder.populationSize')"
                      :disabled="continueConfirmation"
                      @keypress="allowOnlyNumbers"
                      @paste="blockInvalidPaste"
                    )
                b-col(md="6", class="mt-50")
                  b-form-group(:label="$t('label.sampleNumberToRequest')", class="mb-0")
                    div.d-flex.align-items-center(style="height: calc(2.25rem + 2px);")
                      span {{ sampleSizes[controlResponsibleIdx] }}

            b-button(
              class="mt-1 mr-1"
              :disabled="isSubmitting"
              v-show="!continueConfirmation && !route.params.event",
              v-ripple.400="'rgba(255, 255, 255, 0.15)'",
              variant="warning",
              @click="schedulleEventAndSendEmails()"
            )
              | {{ $t('message.program_confirmation_fetch') }}
            b-button(
              class="mt-1 mr-1"
              :disabled="isSubmitting"
              v-show="!continueConfirmation",
              v-ripple.400="'rgba(255, 255, 255, 0.15)'",
              variant="primary",
              @click="handleEnableConfirmation"
            )
              | {{ $t('message.continuar_confirmation') }}

      // Metadata
      b-row(v-show="process.metadata && process.metadata.length", :style="{ visibility: metadataVisible ? 'visible' : 'hidden' }")
        b-col(cols="12")
          b-card(:title="$t('aditional_information')")
            b-card-text
              b-form-group(
                v-for="(metadata, indexDos) in process.metadata", :key="indexDos"
                :label="$t(`metadata.${metadata.name}`)",
                :label-for="$t(`metadata.${metadata.name}`)",
                description=""   
              )
                validation-provider(
                  :name="$t(`metadata.${metadata.name}`)"
                  rules="required"
                  v-slot="{ errors }"
                )
                  v-select(
                    v-if="metadata.type === 'select'"
                    v-model="metadata.answer",
                    :multiple="false",
                    :options="metadataOptionsFiltered[metadata.name]",
                    :placeholder="$t(`placeholder.${metadata.name}`)",
                    @search="(search, loading) => onSearch(search, loading, metadata.name)",
                    v-b-tooltip.focus.v-info.top="$t('search_criteria')"
                    :key="'select'+indexDos"
                  )
                  b-form-input(
                    v-else-if="metadata.type === 'input'"
                    v-model="metadata.answer"
                    :placeholder="$t(`placeholder.${metadata.name}`)"
                  )
                  small(class="text-danger") {{ errors[0] }}

    div(v-show="continueConfirmation")

      // Controls
      b-row(v-if="process.activities && process.activities.length")
        b-col(cols="12")
          b-card.mb-2.bg-primary
            h3.card-title.mb-0.text-center.text-white.text-uppercase.font-weight-bold {{ $t('message.evaluation') }}
      b-row(v-for="(control, controlIdx) in process.activities", :key="controlIdx")
        b-col(cols="12")
          b-card(:id="'control-card-' + controlIdx")
            div.d-flex.justify-content-between.align-items-start.flex-wrap
              div.d-flex.align-items-center.control-title-toggle(v-if="controlIndex == null", @click="toggleControlCollapse(control)")
                feather-icon(:icon="control.collapsed ? 'ChevronRightIcon' : 'ChevronDownIcon'", size="18", class="mr-50 flex-shrink-0")
                h4.card-title.mb-0 {{ getControlTitle(control, controlIdx) }}
                span.expand-control-hint.text-uppercase ({{ control.collapsed ? $t('message.expandControlToEvaluate') : $t('message.hideControl') }})
              h4.card-title.mb-0(v-else) {{ getControlTitle(control, controlIndex) }}
              span(
                v-if="!isNewConfirmation && controlIndex == null && getControlStatusText(control)",
                :class="getControlStatusText(control).variant === 'warning' ? 'control-status-text control-status-warning' : 'control-status-text text-' + getControlStatusText(control).variant"
              )
                | {{ getControlStatusText(control).text }}
            small.d-block.mb-2(v-if="controlIndex == null && getControlResponsibleWorker(control)")
              | {{ $t('label.responsible') }}: {{ getControlResponsibleWorker(control).title }}
            b-row(v-if="controlIndex == null", class="mt-2")
              b-col(cols="4")
                b-form-group(:label="$t('label.populationSize')", :description="$t('label.populationSizeDescription')")
                  b-form-input(
                    :value="control.population"
                    type="text"
                    disabled
                  )
              b-col(cols="4")
                b-form-group(:label="$t('label.sampleNumberToRequest')")
                  div.d-flex.align-items-center(style="height: calc(2.25rem + 2px);")
                    span {{ sampleSizes[controlIdx] }}
            hr(v-if="controlIndex == null && !control.collapsed")
            b-row(
              v-for="(behaviour, behaviourIndex) in control.behaviours",
              :key="behaviourIndex",
              v-show="controlIndex != null || !control.collapsed"
            )
              b-col(cols="12")
                behaviour-question(
                  :behaviour="behaviour",
                  :allow-add-improvement="controlIndex == null",
                  :clientId="clientId",
                  :activityName="control.name",
                  @answered="(answer) => (behaviour.answer = answer)"
                  @commented="(comment) => (behaviour.comment = comment)"
                  @improvementModified="(improvement) => (behaviour.improvement = improvement)"
                  @improvementRemoved="() => (delete behaviour.improvement)"
                  @fileToUpload="(files) => (behaviour.file = files)"
                  @deleteKey="(key) => deleteKey(key, behaviour)"
                )
                //- :allow-add-commitment="!commitment_functionality && isOnline",

      // Upload image
      b-row(v-if="process.requireImage")
        b-col(cols="12")
          b-card(
            :title="$t('message.upload_image')",
            :sub-title="$t('message.upload_image_description')"
          )
            b-card-text
              b-button.mr-1(
                :disabled="isSubmitting"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                type="button",
                variant="info",
                @click="uploadImage()"
              )
                | {{ $t('message.upload') }}
              image-compressor(
                style="display: none",
                :done="getImgCompressed",
                :scale="scale",
                :quality="quality",
                :maxWidth="maxWidth",
                ref="compressor"
              )
              small(v-if="imgData.fileInfo")
                | {{ imgData.fileInfo.name }}
              small(v-else, class="text-danger")
                | {{ $t('message.upload_image_required') }}

      // Add improvement
      b-row(v-if="add_improvement_in_confirmation && controlIndex == null")
        b-col(cols="12")
          b-card(:title="$t('add_improvement')")
            //- b-form-group
              b-col(cols="12")
                ul.list-group.mb-1
                  li.list-group-item.d-flex.justify-content-between.align-items-center.pt-0.pb-0(v-for="(improvement, index) in improvements" :key="index")
                    span
                      | {{ improvement.note }}
                    div
                      edit-button(@clicked="handleImprovementEdit(improvement, index)")
                      delete-button(v-b-modal="'improvement list' + index")
                      b-modal(
                        :id="'improvement list' + index" 
                        centered='' 
                        no-close-on-backdrop='' 
                        modal-class='modal-danger' 
                        ok-variant='danger' 
                        cancel-variant='outline-secondary' 
                        :title="$t('message.confirm_action')" 
                        :ok-title="$t('message.delete')" 
                        :cancel-title="$t('message.cancel')" 
                        @ok="removeImprovement(index)"
                      )
                        | {{ commitment_functionality ? $t('message.confirm_delete_commitment') : $t('message.confirm_delete_improvement') }}
                b-button(
                  :disabled="isSubmitting",
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'",
                  type="button",
                  variant="primary"
                  @click="isImprovementHandlerSidebarActive = true"
                )
                  | {{ $t('message.add') }}
            b-card-text
              b-button(
                variant="info"
                :disabled="isOpeningCaseForm || isSubmitting"
                @click="createMultiBehaviourCase"
              )
                | {{ $t('message.add') }}
              span.ml-2(v-show="isOpeningCaseForm")
                | {{ $t('message.loading') }}

      // General Conclusion
      b-row(v-if="!isForm && controlIndex == null")
        b-col(cols="12")
          b-card(:title="$t('message.generalConclusion')")
            b-card-text
              b-form-textarea(v-model="generalConclusion", rows="3")

      // Enviar evaluación (modo respuesta individual de un control, link de mail al responsable)
      b-row(v-if="controlIndex != null")
        b-col(cols="12")
          b-card(:title="$t('message.End_Confirmation')")
            b-card-text
              b-button(
                :disabled="isSubmitting",
                v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                type="button",
                variant="success",
                @click="submitControlResponse"
              )
                | {{ $t('message.submitControlResponse') }}

      // End confirmation
      b-row(v-if="controlIndex == null")
        b-col(cols="12")
          b-card(
            :title="$t('message.End_Confirmation')",
            :sub-title="$t('message.please_check_all_answers_correct')"
          )
            b-card-text
              b-button.mr-2(
                v-if="isOnline",
                :disabled="isSubmitting",
                v-ripple.400="'rgba(186, 191, 199, 0.15)'",
                type="button",
                variant="outline-success"
                @click="validateAndSubmit(process, true)"
              )
                | {{ $t('message.save_draft') }}
              b-button(
                :disabled="isSubmitting || (process.requireImage && !imgData.fileInfo)",
                v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                type="button",
                variant="success",
                @click="checkBehavioursAndOpenModal"
              )
                | {{ $t('message.submit') }}
              b-modal(
                :id="'presence-validation-modal'"
                centered
                no-close-on-backdrop
                modal-class="modal-success"
                ok-variant="success"
                cancel-variant="outline-secondary"
                :title="$t('message.validate_presence')"
                :ok-title="$t('message.submit')"
                :cancel-title="$t('message.cancel')"
                :ok-disabled="!isPresenceValidated || isSubmitting"
                @ok="validateAndSubmit(process, false)"
              )
                div.mb-2(v-if="!isEvaluatedControlResponsible")
                  | {{ $t('message.presence_validation_message') }}
                div.d-flex.align-items-center.mt-2(v-if="!isEvaluatedControlResponsible")
                  b-button.mr-1(
                    :disabled="isSendingPresenceValidationEmail || isSubmitting",
                    v-show="!isPresenceValidationEmailSent && !isPresenceValidated",
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                    variant="info",
                    @click="activatePresenceValidation"
                  )
                    | {{ $t('message.send_presence_validation_email') }}
                  span(v-show="isSendingPresenceValidationEmail")
                    | {{ $t('message.sending') }}
                  b-button.mr-1(
                    :disabled="isValidatingPresence || isSubmitting",
                    v-show="isPresenceValidationEmailSent && !isPresenceValidated",
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'",
                    variant="warning",
                    @click="validatePresence"
                  )
                    | {{ $t('message.validate_presence') }}
                  span(v-show="isValidatingPresence")
                    | {{ $t('message.validating') }}
                div(
                  v-show="isPresenceValidated",
                  class="h5 text-success mb-0"
                )
                  | {{ isEvaluatedControlResponsible ? $t('message.presence_validated_responsible') : $t('message.presence_validated') }}

    todo-task-handler-sidebar(
      v-model="isImprovementHandlerSidebarActive",
      :task="improvement",
      :taskIndex="improvementIndex",
      :clear-task-data="clearImprovementData",
      :domains="domains",
      :optionsMetadata="optionsMetadata",
      handlerId="improvement",
      @add-task="addImprovement",
      @update-task="updateImprovement"
      @remove-task="removeImprovement"
    )

  b-modal(
    :id="'control-responsible-email-summary-modal'"
    centered
    no-close-on-backdrop
    ok-only
    :title="$t('message.controlResponsibleEmailSummaryTitle')"
    :ok-title="$t('message.close')"
    @ok="acknowledgeEmailSummary"
    @hidden="acknowledgeEmailSummary"
  )
    div(v-if="emailSummary && emailSummary.sent.length")
      h6.text-success {{ $t('message.controlResponsibleEmailSummarySent') }}
      ul
        li(v-for="(item, idx) in emailSummary.sent", :key="'sent-' + idx")
          | {{ item.index + 1 }}- {{ item.control }} ({{ item.responsible }} - {{ item.email }})
    div(v-if="emailSummary && emailSummary.sendError.length", class="mt-2")
      h6.text-danger {{ $t('message.controlResponsibleEmailSummarySendError') }}
      ul
        li(v-for="(item, idx) in emailSummary.sendError", :key="'sendError-' + idx")
          | {{ item.index + 1 }}- {{ item.control }} ({{ item.responsible }} - {{ item.email }})
    div(v-if="emailSummary && emailSummary.noEmail.length", class="mt-2")
      h6.text-warning {{ $t('message.controlResponsibleEmailSummaryNoEmail') }}
      ul
        li(v-for="(item, idx) in emailSummary.noEmail", :key="'noEmail-' + idx")
          | {{ item.index + 1 }}- {{ item.control }} ({{ item.responsible }})
    div(v-if="emailSummary && emailSummary.skipped.length", class="mt-2")
      h6.text-secondary {{ $t('message.controlResponsibleEmailSummarySkipped') }}
      ul
        li(v-for="(item, idx) in emailSummary.skipped", :key="'skipped-' + idx")
          | {{ item.index + 1 }}- {{ item.control }}
    div(v-if="emailSummary && emailSummary.noResponsible.length", class="mt-2")
      h6.text-danger {{ $t('message.controlResponsibleEmailSummaryNoResponsible') }}
      ul
        li(v-for="(item, idx) in emailSummary.noResponsible", :key="'noResponsible-' + idx")
          | {{ item.index + 1 }}- {{ item.control }}
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch, set, nextTick } from "@vue/composition-api";
import { BRow, BCol, BCard, BCardBody, BCardText, BButton, BFormGroup, BFormSelect, BFormDatepicker, BFormTimepicker, BModal, VBModal, BFormTextarea, BAlert, BFormCheckbox, BSpinner } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import useCommon from "@/views/organization/useCommon";
import useConfirmationForm from './useConfirmationForm'
import BehaviourQuestion from './BehaviourQuestion.vue'
import i18n from '@/libs/i18n'
import useNotifications from '@/composables/useNotifications'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import ImageCompressor from '@/views/habit/ImageCompressor.vue';
import { useRouter } from '@core/utils/utils'
import store from '@/store'
import { VBTooltip } from 'bootstrap-vue'
import TodoTaskHandlerSidebar from '@/views/apps/todo/TodoTaskHandlerSidebar.vue'
import useCommonDashboards from '@/views/habit/useCommonDashboards'
import EditButton from '@/views/components/Shared/Buttons/EditButton.vue'
import DeleteButton from '@/views/components/Shared/Buttons/DeleteButton.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { residualRiskColors } from '@/constants'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BButton,
    BFormGroup,
    BFormSelect,
    BehaviourQuestion,
    vSelect,
    BFormDatepicker,
    BFormTimepicker,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    ImageCompressor,
    TodoTaskHandlerSidebar,
    EditButton,
    DeleteButton,
    Loading,
    BModal,
    BAlert,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  props: {
    isNewConfirmation: {
      type: Boolean,
      required: true,
    },
    isReEvaluation: {
      type: Boolean,
      default: false,
    },
    // Modo "respuesta individual de un control" (link de mail al responsable de un control):
    // limita el formulario a ese único control, ignorando el resto del flujo de evaluación.
    controlIndex: {
      type: Number,
      default: null,
    },
  },
  computed: {
    processName() {
      return i18n.t('message.process') + `: ${this.process.code ? `${this.process.code} / ${this.process.name}` : this.process.name || ''}`
    },
    isForm() {
      return this.process.code?.startsWith('F')
    },
    // En "new" (no re-evaluación) el card del control a evaluar nunca llega a mostrarse en esta
    // ruta: "Continuar" crea la confirmación y redirige de una a la ruta "edit" (ver comentario en
    // enableConfirmation, useConfirmationForm.js). El ícono de scroll-hasta-el-control no tiene
    // destino acá, así que se oculta.
    showGoToControlIcon() {
      return !(this.isNewConfirmation && !this.isReEvaluation)
    },
  },
  setup(props, { root }) {
    const {
      improvements, userData, show, submit, event, process, sampleSizes, selectedWorker, selectWorkerDisabled, selectedSupervisor, selectSupervisorDisabled, schedulleEvent, schedulleEventAndSendEmails, continueConfirmation, isSubmitting, selectDateDisabled, enableConfirmation, saveControlResponsible, interval, startTimer, stopTimer, metadataVisible, activatePresenceValidation, isSendingPresenceValidationEmail, isPresenceValidationEmailSent, validatePresence, isValidatingPresence, isPresenceValidated, generalConclusion, createMultiBehaviourCase, isOpeningCaseForm, emailSummary, showEmailSummaryModal, acknowledgeEmailSummary, respondAccessDenied, respondAlreadyCompleted, submitControlResponse, reloadControlsStatus, isReloadingControlsStatus,
    } = useConfirmationForm(props.isNewConfirmation, props.isReEvaluation, props.controlIndex)
    const { getWorkersSupervisedForDropDown, workersSupervised, getWorkersTotalForDropDown, workersTotal, getMetadataForDropDown, metadataTypeSelectNotMapped, metadataNotMapped } = useCommon()
    const isOnline = computed(() => store.state.app.isOnline)
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    // Si el control todavía no tiene responsible_id, intenta precargarlo matcheando
    // por nombre exacto contra el texto libre viejo (control.responsible). Además, una sola vez
    // por control, guarda una foto del valor inicial (_initialResponsibleId) para poder detectar
    // si el usuario lo cambia, e inicializa el estado del checkbox "aplicar también al control
    // general" (applyToBaseControl). responsibleLocked NO se inicializa acá si ya viene de la base
    // (confirmación existente): solo se pone en false para controles que todavía no tienen ese campo
    // (evaluación nueva, viene del proceso, no de una confirmación guardada).
    watch([() => process.value.activities, workersTotal], () => {
      if (!process.value.activities?.length || !workersTotal.value?.length) return

      process.value.activities.forEach(control => {
        if (!control.responsible_id && control.responsible) {
          const match = workersTotal.value.find(worker => worker.title?.trim().toLowerCase() === control.responsible.trim().toLowerCase())
          if (match) control.responsible_id = match.value
        }

        if (control._initialResponsibleId === undefined) {
          set(control, '_initialResponsibleId', control.responsible_id || null)
          set(control, 'applyToBaseControl', false)
          set(control, 'isSavingResponsible', false)
          set(control, 'skipNotification', !!control.skipNotification)
        }

        if (control.responsibleLocked === undefined) set(control, 'responsibleLocked', false)
      })
    }, { immediate: true })

    // Cards de control colapsadas por defecto (vista Edit, ver v-if="controlIndex == null" en el
    // template) para no hacer tan larga la pantalla. No depende de workersTotal (a diferencia del
    // watch de arriba) para que el colapso se vea desde el primer render, sin esperar ese fetch.
    watch(() => process.value.activities, () => {
      process.value.activities?.forEach(control => {
        if (control.collapsed === undefined) set(control, 'collapsed', true)
      })
    }, { immediate: true })

    const toggleControlCollapse = control => {
      control.collapsed = !control.collapsed
    }

    const responsiblesCollapsed = ref(true)
    const toggleResponsiblesCollapsed = () => {
      responsiblesCollapsed.value = !responsiblesCollapsed.value
    }

    watch(continueConfirmation, value => {
      responsiblesCollapsed.value = value
    }, { immediate: true })

    // Usado por el ícono de "ir al control" en "Responsables de cada control": expande el
    // control (si estaba colapsado) y hace scroll hasta su card. Scroll manual (no scrollIntoView)
    // para descontar la altura del navbar fijo (.header-navbar) y que el título no quede tapado.
    const goToControl = index => {
      const control = process.value.activities?.[index]
      if (control) control.collapsed = false

      nextTick(() => {
        const element = document.getElementById(`control-card-${index}`)
        if (!element) return

        const fixedHeaderHeight = document.querySelector('.header-navbar')?.getBoundingClientRect().height || 0
        const extraOffset = 16
        const targetTop = element.getBoundingClientRect().top + window.scrollY - fixedHeaderHeight - extraOffset

        window.scrollTo({ top: targetTop, behavior: 'smooth' })
      })
    }

    const clientId = userData.role !== "admin" ? userData.client.$oid : null;
    const eventInfo = ref(null)
    const compressor = ref(null)
    const imgData = ref({})
    const scale = ref(100)
    const quality = ref(50)
    const maxWidth = ref(640)
    const metadataOptionsFiltered = ref({})
    const improvementIndex = ref(-1)
    const isImprovementHandlerSidebarActive = ref(false)
    const TODO_APP_STORE_MODULE_NAME = 'app-todo'
    const now = new Date()

    const { getDomains, getDatesFromRange } = useCommonDashboards()
    const domains = computed(() => getDomains(clientId))

    const blankImprovement = {
      client_id: { link: clientId },
      note: '',
      createdAt: now,
      dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      description: '',
      assignee: null,
      documentFile: {}
    }

    const improvement = ref(JSON.parse(JSON.stringify(blankImprovement)))

    const clearImprovementData = () => {
      improvement.value = JSON.parse(JSON.stringify(blankImprovement))
      improvementIndex.value = -1
    }

    const optionsMetadata = computed(() => store.state[TODO_APP_STORE_MODULE_NAME].optionsMetadata)

    watch(metadataNotMapped, val => {
      if (val && val.length) {
        val.forEach(e => {
          // Set default creation date
          if (e.name === "creation_date") {
            e.answer = `${now.getFullYear()}-${now.getMonth() < 9 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1}-${now.getDate() < 10 ? "0" + now.getDate() : now.getDate()}`
          }
          // Set default instance leader
          if (e.name === "instance_leader") e.answer = userData.username
        })
        blankImprovement.metadata = val
        if (!improvement.value._id) improvement.value = { ...improvement.value, metadata: val }
      }
    })

    const handleImprovementEdit = (improvementData, index) => {
      improvementIndex.value = index
      improvement.value = improvementData
      isImprovementHandlerSidebarActive.value = true
    }

    const addImprovement = (improvementData) => {
      improvements.value.push(improvementData)
    }

    const updateImprovement = (improvementData, index) => {
      improvements.value[index] = improvementData
    }

    const removeImprovement = (index) => {
      improvements.value.splice(index, 1)
      isImprovementHandlerSidebarActive.value = false
    }

    const { router, route } = useRouter()

    const { commitment_functionality, add_improvement_in_confirmation, skipPresenceValidation } = JSON.parse(localStorage.getItem('clientData') || '{}')

    const uploadImage = () => {
      compressor.value.$el.click()
    }

    const getImgCompressed = (obj) => {
      imgData.value = {
        fileInfo: obj.compressed,
        destinationFolder: `${userData.client.$oid}/confirmations`
      }
    }

    const openTaskHandlerSidebar = () => {
      store.commit('app-todo/SET_TOGGLE_TASK_HANDLER_SIDEBAR', true)
    }

    const validateEventInfo = () => new Promise((resolve, reject) => {
      eventInfo.value.validate().then(success => {
        if (success) {
          // Check if all behaviours that require evidence have files
          let evidencesValidated = true
          if (process.value.activities?.length) {
            for (const control of process.value.activities) {
              if (control.behaviours?.length) {
                for (const behaviour of control.behaviours) {
                  if (behaviour.requiresEvidence && !behaviour.file?.length) {
                    evidencesValidated = false
                    break
                  }
                }
              }
              if (!evidencesValidated) break
            }
          }

          if (evidencesValidated) resolve(true)
          else reject()
        } else {
          reject()
        }
      })
    })

    const handleEnableConfirmation = async () => {
      const valid = await eventInfo.value.validate()
      if (!valid) return showErrorMessage(i18n.t('message.requiredFieldsIncomplete'))

      await enableConfirmation()
    }

    const validateAndSubmit = (process, isDraft) => {
      if (isDraft) submit(process, imgData.value, isDraft)
      else {
        validateEventInfo()
          .then(() => submit(process, imgData.value, isDraft))
          .catch((error) => {
            console.log(error)
            showErrorMessage(i18n.t('message.requiredFieldsIncomplete'))
          })
      }
    };

    const onSearch = (search, loading, property) => {
      // Only enable search when text input is at least 3 characters long
      if (search.length < 3) {
        metadataOptionsFiltered.value[property] = metadataTypeSelectNotMapped.value[property]?.slice(0, 100)
      } else {
        loading(true)
        // Simulated ajax query
        setTimeout(() => {
          metadataOptionsFiltered.value[property] = metadataTypeSelectNotMapped.value[property]?.filter(e => e.toLowerCase().includes(search.toLowerCase()))
          loading(false)
        }, 100)
      }
    }

    const allowOnlyNumbers = e => {
      const keyCode = e.keyCode || e.which
      if (keyCode < 48 || keyCode > 57) {
        e.preventDefault()
      }
    }

    const blockInvalidPaste = e => {
      const pasted = (e.clipboardData || window.clipboardData).getData('text')
      // Allow only numbers in pasted content
      if (!/^\d+$/.test(pasted)) {
        e.preventDefault()
      }
    }

    const deleteKey = (key, behaviour) => {
      behaviour.evidenceKey = behaviour.evidenceKey.filter(k => k !== key)
      process.value.allFileKeys = process.value.allFileKeys.filter(k => k !== key)
    }

    const checkBehavioursAndOpenModal = () => {
      // Verificar que todos los comportamientos estén respondidos
      let allBehavioursAnswered = true
      if (process.value.activities?.length) {
        for (const control of process.value.activities) {
          if (control.behaviours?.length) {
            for (const behaviour of control.behaviours) {
              if (!behaviour.answer) {
                allBehavioursAnswered = false
                break
              }
            }
          }
          if (!allBehavioursAnswered) break
        }
      }

      if (!allBehavioursAnswered) {
        showErrorMessage(i18n.t('message.allBehavioursMustBeAnswered'))
      } else if (skipPresenceValidation) {
        root.$bvModal
          .msgBoxConfirm(i18n.t('message.confirm_finish_evaluation'), {
            centered: true,
            noCloseOnBackdrop: true,
            modalClass: 'modal-success',
            okVariant: 'success',
            cancelVariant: 'outline-secondary',
            title: i18n.t('message.finish'),
            okTitle: i18n.t('message.submit'),
            cancelTitle: i18n.t('message.cancel'),
            okDisabled: isSubmitting,
            hideHeaderClose: false,
          })
          .then(value => {
            if (value) validateAndSubmit(process.value, false)
          })
      } else {
        // Si el evaluado es responsable de algún control, no hace falta validar presencia por email
        isPresenceValidated.value = isEvaluatedControlResponsible.value
        root.$bvModal.show('presence-validation-modal')
      }
    }

    // Abre/cierra el modal de resumen de notificación a responsables en respuesta al estado
    // manejado por el composable (enableConfirmation/saveControlResponsible)
    watch(showEmailSummaryModal, value => {
      if (value) root.$bvModal.show('control-responsible-email-summary-modal')
      else root.$bvModal.hide('control-responsible-email-summary-modal')
    })

    onMounted(() => {
      getWorkersSupervisedForDropDown()
      getWorkersTotalForDropDown()
      getMetadataForDropDown({ type: "select", option: "notMapped" })
      getMetadataForDropDown({ category: "improvement", option: "notMapped" })
      show()
      if (route.value.params.user || props.isNewConfirmation) startTimer()
    })

    onUnmounted(() => {
      if (interval.value) stopTimer()
    })

    watch(metadataTypeSelectNotMapped, () => {
      for (const metadata in metadataTypeSelectNotMapped.value) {
        set(metadataOptionsFiltered.value, metadata, metadataTypeSelectNotMapped.value[metadata]?.slice(0, 100))
      }
    })

    const getControlTitle = (control, index) => {
      const controlNumber = index + 1
      const controlName = control.name || ''
      return `${controlNumber}. ${controlName}`
    }

    // Lee el responsable vigente para ESTA evaluación (control.responsible_id, editable más
    // arriba), no el texto viejo de la colección control, para que se actualice si se cambia el
    // select. Se usa tanto para el texto de menor jerarquía bajo el título como para el badge de
    // estado (necesita también el email).
    const getControlResponsibleWorker = control => {
      return workersTotal.value?.find(worker => worker.value === control.responsible_id) || null
    }

    // true si el evaluado (selectedWorker) figura como responsable de al menos un control de la
    // evaluación. En ese caso la validación de presencia se da por hecha sin email (el propio
    // evaluado completa la evaluación, así que su presencia es evidente).
    const isEvaluatedControlResponsible = computed(() => {
      return !!(selectedWorker.value && process.value.activities?.some(
        control => control.responsible_id && control.responsible_id === selectedWorker.value
      ))
    })

    // Texto de estado (solo vista Edit, ver v-if en el template): "sin responsable" / "mail
    // enviado, pendiente de respuesta" / "notificación desactivada" / "ya respondido", con el
    // email del responsable. Se apoya en responsibleLocked (se pone en true en el mismo momento
    // en que se intenta enviar el mail, ver startEvaluation/saveControlResponsible),
    // skipNotification (el responsable quedó asignado pero se optó por no enviarle mail) y
    // completed (seteado por submitControlResponse).
    const getControlStatusText = control => {
      if (control.completed) {
        const email = getControlResponsibleWorker(control)?.email || ''
        return { text: i18n.t('message.controlAnsweredByNotice', { email }), variant: 'success' }
      }
      if (control.responsibleLocked) {
        if (control.skipNotification) {
          return { text: i18n.t('message.controlResponsibleEmailSummarySkipped'), variant: 'secondary' }
        }
        const email = getControlResponsibleWorker(control)?.email
        if (!email) {
          return { text: i18n.t('message.controlResponsibleNoEmailNotice'), variant: 'danger' }
        }
        return { text: i18n.t('message.controlMailSentNotice', { email }), variant: 'warning' }
      }
      if (!control.responsible_id) {
        return { text: i18n.t('message.controlNoResponsibleNotice'), variant: 'danger' }
      }
      return null
    }

    return {
      show,
      submit,
      event,
      route,
      process,
      sampleSizes,
      workersSupervised,
      workersTotal,
      saveControlResponsible,
      selectedWorker,
      selectWorkerDisabled,
      selectedSupervisor,
      selectSupervisorDisabled,
      selectDateDisabled,
      schedulleEvent,
      schedulleEventAndSendEmails,
      enableConfirmation,
      handleEnableConfirmation,
      continueConfirmation,
      isSubmitting,
      required,
      eventInfo,
      validateAndSubmit,
      compressor,
      scale,
      quality,
      maxWidth,
      uploadImage,
      getImgCompressed,
      imgData,
      isOnline,
      commitment_functionality,
      add_improvement_in_confirmation,
      openTaskHandlerSidebar,
      onSearch,
      metadataOptionsFiltered,
      metadataVisible,
      isImprovementHandlerSidebarActive,
      improvement,
      improvements,
      domains,
      clearImprovementData,
      improvementIndex,
      handleImprovementEdit,
      addImprovement,
      removeImprovement,
      updateImprovement,
      optionsMetadata,
      clientId,
      activatePresenceValidation,
      isSendingPresenceValidationEmail,
      isPresenceValidationEmailSent,
      validatePresence,
      isValidatingPresence,
      isPresenceValidated,
      allowOnlyNumbers,
      blockInvalidPaste,
      residualRiskColors,
      generalConclusion,
      deleteKey,
      checkBehavioursAndOpenModal,
      createMultiBehaviourCase,
      isOpeningCaseForm,
      getControlTitle,
      getControlResponsibleWorker,
      getControlStatusText,
      toggleControlCollapse,
      responsiblesCollapsed,
      toggleResponsiblesCollapsed,
      goToControl,
      emailSummary,
      acknowledgeEmailSummary,
      respondAccessDenied,
      respondAlreadyCompleted,
      submitControlResponse,
      reloadControlsStatus,
      isReloadingControlsStatus,
      isEvaluatedControlResponsible,
    }
  },
}
</script>

<style lang="scss">
.form-group {
  label {
    font-size: 1.2rem;
    font-weight: 200;
  }

  // Evaluador / Evaluado / Fecha de evaluación: misma jerarquía que el texto plano de cada
  // control en "Responsables de cada control" (que no usa .form-group label), no el tamaño
  // grande por defecto de arriba.
  label.control-field-label {
    font-size: 1rem;
    font-weight: 400;
  }
}

.form-notice-alert {
  font-size: 0.9rem;
}

.control-responsibles-title {
  padding-top: 0.5rem;
}

.control-responsibles-text {
  font-size: .95rem;
  font-weight: 400;
  /* line-height: 1.9; */
}

.worker-email {
  font-size: 0.8rem;
}

.worker-email-value {
  color: #495057;
}

/* El select de responsable no debe achicar ni cortar el contenido (nombre + email):
   si no entra en una línea, debe crecer hacia abajo en vez de recortarse. */
.control-responsible-select {
  ::v-deep .vs__dropdown-toggle {
    height: auto;
    min-height: 38px;
  }

  ::v-deep .vs__selected {
    white-space: normal;
    word-break: break-word;
  }
}

.selected-worker-info {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  max-width: 100%;
}

.selected-worker-name {
  font-size: 0.875rem;
}

.selected-worker-email {
  font-size: 0.75rem;
}

@media (max-width: 575.98px) {
  .selected-worker-name {
    font-size: 0.75rem;
  }

  .selected-worker-email {
    font-size: 0.68rem;
  }
}

.control-responsible-actions {
  font-size: 0.8rem;

  .custom-control-label {
    padding-top: 2px;
  }

  // Habilitado pero sin activar: gris más oscuro que el gris claro de deshabilitado.
  // Activado (checked) mantiene el color primary por defecto.
  .custom-control-input:not(:disabled):not(:checked) ~ .custom-control-label::before {
    background-color: #6c757d;
    border-color: #6c757d;
  }
}

.control-status-text {
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
}

.control-title-toggle {
  cursor: pointer;
  user-select: none;
}

.go-to-control-icon {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include'; // define $warning
@import 'scss/variables/_variables-components'; // define $warning-darker (usa $warning, ya disponible acá)

// El .text-warning de Bootstrap se ve muy claro/amarillo para este texto informativo.
// $warning-darker es la variable compartida (assets/scss/variables/_variables-components.scss).
.control-responsibles-text {
  color: $warning-darker;
}

.control-status-warning {
  color: $warning-darker;
}

.expand-control-hint {
  margin-left: 0.75rem;
  font-weight: 700;
  color: $warning-darker;
}
</style>